module.exports = __webpack_public_path__ + "static/media/footer-logo-2.01664ccf.jpg";